import NotifyBase from './base';
import PNotify from 'pnotify/dist/es/PNotify';
export default class NotifyCommand extends NotifyBase {
  init(){
    this.scope = 'data.command';
    this.elementId = 'notify-command-wrap';
    this.stack = {
      dir2: 'right'
    };
    this.options = {
      delay: 12000,
      modules: {
        Animate: {
          outClass: 'fadeOutLeft'
        }
      }
    };
    super.init();
  }
  onEvent(newVal, oldVal, projectPath){
    let notify:PNotify = super.onEvent(newVal, oldVal, projectPath);
    this.setClickEvent(notify, newVal);
  }
  setClickEvent(notify: PNotify, newVal){
    // notifyのテキストに notify-command というIDを持ったアンカータグを入れておく、
    // 入れておく場所はconfig/locales/notify/ja.ymlのcommandセクション
    let anchorElement = document.getElementById('notify-command');
    anchorElement.removeAttribute('id');
    anchorElement.addEventListener('click', (e) => {
      e.preventDefault();
      notify.close();
      // jbuilderでresponse_thenのoption > command >に
      // event_nameとdetailを格納し、notifyの中にいれたaタグをクリックした際に
      // CustomEventを起こす。
      let eventName = newVal.command.event_name;
      let detail = newVal.command.detail;
      let customEvent = new CustomEvent(eventName, { detail: detail });
      document.dispatchEvent(customEvent);
      return false;
    })
  }
}
